import React from 'react';
import { useCalendar } from '../context/CalendarContext';
import { getDaysInMonth, startOfMonth, format, getDay, addDays, parseISO, getYear as getYearFromDateFns } from 'date-fns';
import { DayData } from '../types';
import DayCell from './DayCell';

interface MonthViewProps {
  month: number;
  year: number;
}

const MonthView: React.FC<MonthViewProps> = ({ month, year }) => {
  const { getInitialDayData, calendarData, currentYear } = useCalendar(); // Adicionado calendarData e currentYear
  const firstDayOfMonth = startOfMonth(new Date(year, month));
  const daysInMonth = getDaysInMonth(new Date(year, month));

  const daysOfWeek = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

  const blanks = Array(getDay(firstDayOfMonth)).fill(null);
  const monthDays = Array.from({ length: daysInMonth }, (_, i) => addDays(firstDayOfMonth, i));

  return (
    <div className="grid grid-cols-7 gap-1 text-center text-sm">
      {daysOfWeek.map(day => (
        <div key={day} className="font-medium text-gray-600 py-1">{day}</div>
      ))}
      {blanks.map((_, index) => (
        <div key={`blank-${index}`} className="border rounded-md p-1"></div>
      ))}
      {monthDays.map(date => {
        const dateString = format(date, 'yyyy-MM-dd');
        // Prioriza dados do calendarData se existirem e pertencerem ao ano atual,
        // caso contrário, usa getInitialDayData como fallback.
        const dayDataFromState = calendarData[dateString];
        const dayData = (dayDataFromState && getYearFromDateFns(parseISO(dateString)) === currentYear) 
                        ? dayDataFromState 
                        : getInitialDayData(date);
        return <DayCell key={dateString} dayData={dayData} />;
      })}
    </div>
  );
};

export default MonthView;